if (!customElements.get("td-subscription-box")) {
  class TdSubscriptionBox extends HTMLElement {
    constructor() {
      super();
      this.selectedOption = false;
      this.activeBox = this.querySelector(".active");
      this.oneTimeLabels = document.querySelectorAll(".your-are-saving-display");
      this.subLabels = document.querySelectorAll(".your-are-saving-display-subs");
      this.sub90Labels = document.querySelectorAll(".your-are-saving-display-subs-90days");
    }

    connectedCallback() {
      const labels = document.querySelectorAll('.product--info-variants_label');
      const sellingPlanSelectors = this.querySelectorAll(".rtx__frequency");
      const sellingPlanOptions = this.querySelectorAll("input[name='selling_plan_select']");
      sellingPlanSelectors.forEach(selector => {
        selector.addEventListener('change', () => { this.setSellingPlan() });
       })
       
      labels.forEach(label => {
        label.addEventListener('click', (label) => {
          const id = label.currentTarget.getAttribute('for');
          this.variantChanged(id);
        });
      });

      sellingPlanOptions.forEach(option => {
        option.addEventListener('change', (opt) => {
          const wrappers = this.querySelectorAll('.rtx__option');
          wrappers.forEach(wrapper => {
            wrapper.classList.remove('rtx--active');
          });
          const option = opt.currentTarget.closest(".rtx__option");
          option.classList.add('rtx--active');
          this.setSellingPlan();
        });
      });
    }
    
    setSellingPlan() {
      this.selectedOption = this.querySelector('.active input[name="selling_plan_select"]:checked'
      )?.value;
      
      if (!this.selectedOption) return;

      if (this.selectedOption == "onetime") {
        this.querySelector(`.active input[name="selling_plan"]`).value = "";
        this.updateVariantsPrice('block', 'none', 'none');
      } else {
        let value = this.querySelector(
          `.rtx-container.active select`
        ).value;
        this.querySelector(`.active input[name="selling_plan"]`).value = value;
        if (!!value) {
          this.querySelector('.active input[name="selling_plan"]').value = value;
          this.updateVariantsPrice('none', 'none', 'block');
        } else if (value == undefined) {
          this.updateVariantsPrice('none', 'block', 'none');
        }
      }
      this.updatePrices();
    }

    variantChanged(id){
      const retextionContainers = this.querySelectorAll('.rtx-container');
      retextionContainers.forEach(container => {
        container.classList.remove('active');
      });
  
      const activeContainer = this.querySelector(`[data-rtx-variant-id="${id}"]`);
      if (activeContainer) {
        activeContainer.classList.add('active');

        const wrappers = this.querySelectorAll('.rtx__option');
        wrappers.forEach(wrapper => {
          wrapper.classList.remove('rtx--active');
        });
        const option = activeContainer.querySelector("[name='selling_plan_select']");
        const optionWrapper = option.closest(".rtx__option");
        optionWrapper.classList.add('rtx--active');
        option.checked = true;
      }

      this.setSellingPlan();
    }

    updatePrices(){
      if (this.selectedOption == "onetime") {
        let onePrice = parseInt(this.querySelector(".active")?.dataset.oneprice);
        onePrice = onePrice / 100;
        const priceDisplay = document.querySelector('.product-price-display');
        priceDisplay.textContent = '$' + onePrice;

      } else if (this.selectedOption === 'subsave') {
        const activeSellWrapper = this.querySelector('.active .rtx--active');
        const onePrice = parseInt(this.querySelector('.active')?.dataset.oneprice);
        const rtxDiscountPrice = this.querySelector('.active')?.dataset.rtxPrice;

        const price = onePrice / 100;

        document.querySelector('.product-price-display').innerHTML = `$${rtxDiscountPrice} <span>$${price}</span>`;

        let value = activeSellWrapper.querySelector('select').value;

        if (value === '593297479') {
          let specprice;
          let comparespecprice;
          if (value !== undefined) {
            specprice = this.querySelector('input[name="product-size"]:checked').getAttribute('90daysprice');
            comparespecprice = (parseFloat(specprice) - parseFloat(specprice) * 0.15).toFixed(2);
          }
          document.querySelector('.product-price-display').innerHTML = `$${comparespecprice} <span>$${specprice}</span>`;
        }
      }
    }

    updateVariantsPrice(onetime, sub, sub90){
      this.oneTimeLabels.forEach(
        (el) => (el.style.display = onetime)
      );
      this.subLabels.forEach(
        (el) => (el.style.display = sub)
      );
      this.sub90Labels.forEach(
        (el) => (el.style.display = sub90)
      );
    }
  }

  customElements.define("td-subscription-box", TdSubscriptionBox);
}
